import { useContext, useEffect, useReducer, useState } from "react"
import { UserContext } from "../../../context/provider/UserProvider"
import { BotonProcesar } from "../../components/buttons/BotonProcesar"
import { LineaCarga } from "../../components/LineaCarga"
import { MultiSelectorFecha } from "../../components/pickers/MultiSelectorFecha"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { convertirSegundosAFormatoHr, formatDate } from "../../../utils/utils"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { Modal } from "../../components/modal/Modal"
import { useModal } from "../../../hooks/useModal"
import { useActividadesIncidencia } from "../../../hooks/actividades/useActividadesIncidencia"
import { ModalProyecto } from "../../components/modal/ModalProyecto"
import { DetalleProyecto } from "../../components/DetalleProyecto"
import { useIncidencias } from "../../../hooks/incidencias/useIncidencias"
import { ContenedorImagen } from "../../components/ContenedorImagen"

const imagenReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

const imagenExtraReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

const docReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

export const ActividadesIncidencia = () => {
    const idTablaActividades = 'idTablaActividades';
    const { stateUser } = useContext(UserContext);
    const [ startDate, setStartDate ] = useState(() => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 7);
        return formatDate(currentDate);
    });
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    const [ isOpenModalActividad, openModalActividad, closeModalActividad ] = useModal(null);
    const [ isOpenModalDetalle, openModalDetalle, closeModalDetalle ] = useModal(null);
    const [ codigoIncidencia, setCodigoIncidencia ] = useState(0);
    const [ participantes, setParticipantes ] = useState('')
    const [ imagenes, envioImagen ] = useReducer(imagenReducer, []);
    const [ imagenesExtra, envioImagenExtra ] = useReducer(imagenExtraReducer, []);
    const [ documentos, envioDoc ] = useReducer(docReducer, []);
    const [ codigoEstado, setCodigoEstado ] = useState(0)
    const estadosIncidencia = [
        { codEstado: 48, nomEstado: "En Proceso", abrevEstado: "PROC"},
        { codEstado: 59, nomEstado: "Solucionado", abrevEstado: "SOL"},
        { codEstado: 7, nomEstado: "Cerrado", abrevEstado: "CERR"},
    ];


    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";


    const labelEstado = (codEstado, nomEstado) => {
        let color = 'bg-gray-500';
        switch(codEstado){
            case 40: color = 'bg-yellow-600';
            break;
            case 48: color = 'bg-green-600';
            break;
            case 59: color = 'bg-red-600';
            break;
            default: color = 'bg-gray-600';
            break;
        }

        return(
            <span className={`${color} relative px-2 text-xs rounded`}>{nomEstado}</span>
        )
    }

    const registrarSolucion = async () => {
        const isValid = await guardarSolucion(codigoIncidencia);
        if(isValid){
            await listarIncidenciaPorUID(startDate, endDate)
            closeModalActividad()
        }
    }

    {/* LOGICA PARA EL GUARDADO DE ARCHIVOS */}
    const parseURLArchivo = async (archivos) => {
        return archivos.map(option => {
            const nuevoObjeto = {};
            Object.keys(option).forEach(key => {
                if(key === 'codIncidenciaArchivo'){
                    nuevoObjeto.codigo = option[key];
                }
                else
                    if(key.startsWith('nom')){
                        nuevoObjeto.nom = option[key];
                    }
                    else
                        if(key.startsWith('url')){
                            nuevoObjeto.url = option[key];
                        }
            });
            return nuevoObjeto;
        })
    }

    const {
        listarIncidenciaPorUID,
        incidenciaPorUID,
        loading
    } = useActividadesIncidencia();

    const {
        listarDetalleIncidencia,
        detalleIncidencia,
        imagenesDetalle,
        datosValidacion,
        imagenesValidacion,
        documentosValidacion,
        listarTipoUrgencia,
        tipoUrgencia,
        listarConceptosIncidencia,
        conceptosIncidencia,
        solucion,
        editarValorSolucion,
        guardarSolucion,
        resetSolucion,
        resolucion
    } = useIncidencias()

    useEffect(() => {
        listarTipoUrgencia()
    },[])

    useEffect(() => {
        listarIncidenciaPorUID(startDate, endDate)
    },[startDate,endDate, codigoEstado])

    useEffect(() => {
        const asincronaImg = async (imagenes,envioImagen) => {
            const urlImagen = await parseURLArchivo(imagenes);
            envioImagen({ tipo: 'Cargar', carga: urlImagen});
        }
        imagenesDetalle.length > 0 ? asincronaImg(imagenesDetalle,envioImagen) : envioImagen({tipo: 'Reiniciar'});
        imagenesValidacion.length > 0 ? asincronaImg(imagenesValidacion,envioImagenExtra) : envioImagenExtra({tipo: 'Reiniciar'});
    },[imagenesDetalle, imagenesValidacion])

    return(
        <>
            {loading && <LineaCarga/>}
            <ContenedorParametros titulo='Actividades por incidencias' tablaId={idTablaActividades}>
                <MultiSelectorFecha
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <i></i>
                <select className={`${classNameSelect}`} value={codigoEstado} onChange={(e)=> setCodigoEstado(Number(e.target.value))}>
                    <option key={'opcionTodosIncidencia'} value={0}>--Todos--</option>
                    {
                        estadosIncidencia.map(est => (
                            <option value={est.codEstado}>{est.nomEstado}</option>
                        ))
                    }
                </select>
                <BotonProcesar onClick={()=> listarIncidenciaPorUID(startDate, endDate)}></BotonProcesar>

            </ContenedorParametros>
            
            <ContenedorTabla>
                <div
                    className=" containerScroll contenedor-tabla w-auto"
                    key={'contenedorTabla'}
                >
                    <table
                        id={idTablaActividades}
                        className="tableResponsive"
                    >
                        <thead>
                            <tr key={'trCabecera'} className="uppercase">
                                <th className="w-[50px]">N°</th>
                                <th className="w-[100px]">Ticket</th>
                                <th className="w-[350px] text-left ">Nombre</th>
                                <th className="w-[350px] text-left ">Empresa</th>
                                <th className="w-[300px]">Fecha derivación</th>
                                <th className="w-[50px]"></th>
                                <th className="w-[150px]">Estado</th>
                                <th className="w-[50px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                incidenciaPorUID.length > 0 ?
                                    incidenciaPorUID.map((inc, i) => (
                                        <tr>
                                            <td className="text-center">{i + 1}</td>
                                            <td className="items-center flex justify-center">
                                                <span className="px-2 text-center w-[60px] relative block rounded bg-blue-600">{inc.codIncidencia}</span>
                                            </td>
                                            <td className="">
                                                <div className="w-[340px] whitespace-nowrap text-ellipsis overflow-hidden">{inc.tituloIncidencia}</div>
                                            </td>
                                            <td className="">{inc.nomEmpresa}</td>
                                            <td className="text-center">{inc.fechaHoraRegistroDerivacion}</td>
                                            <td className="text-center">
                                                {
                                                    !inc.registraSolucion ? 
                                                        <span
                                                            className="bg-blue-500 px-2 rounded cursor-pointer hover:bg-blue-700"
                                                            onClick={async () => {
                                                                await resetSolucion();
                                                                await setCodigoIncidencia(inc.codIncidencia);
                                                                await openModalActividad();
                                                            }}
                                                        >Solucionar</span>
                                                    : <></>
                                                }
                                            </td>
                                            <td className="text-center">{labelEstado(inc.codEstado,inc.nomEstado)}</td>
                                            <td className="text-center">
                                                <img
                                                    title="Ver detalle"
                                                    src="https://img.icons8.com/?size=48&id=dslcyJwWWDHs&format=png"
                                                    alt=""
                                                    className="w-[30px] h-[30px] text-center"
                                                    onClick={async () => {
                                                        await listarDetalleIncidencia(inc.codIncidencia);
                                                        await listarConceptosIncidencia(inc.codProductoInterno)
                                                        setParticipantes(inc.uidSolucionConcatenado)
                                                        await openModalDetalle()
                                                    }}
                                                ></img>
                                            </td>
                                        </tr>
                                    ))
                                : 
                                <tr><td colSpan={8} className="text-center">No hay información para mostrar...</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </ContenedorTabla>

            <ModalProyecto
                isOpen={isOpenModalDetalle}
                closeModal={closeModalDetalle}
                textButtons={{confirm: 'Guardar', denied: 'Cerrar'}}
                validButton={{confirm: false, denied: true}}
                title={`Detalle de incidencia`}
                clasesModal="h-[800px] w-[1000px]"
            >
                <section className="overflow-y-auto containerScroll h-full">
                    <fieldset className="border border-zinc-600 m-2 rounded px-2">
                        <legend className="px-2">Detalle incidencia</legend>
                        <section className="grid grid-cols-[minmax(0,15fr)_minmax(0,35fr)_minmax(0,15fr)_minmax(0,35fr)] gap-y-1 gap-x-2 p-2">
                            <span className="self-center">Usuario registro</span>
                            <input className={`${classNameInput} min-h-0 `} value={detalleIncidencia.uidCreacion} disabled/>
                            <span className="self-center">Empresa</span>
                            <input className={`${classNameInput} min-h-0 `} value={detalleIncidencia.nomEmpresa} disabled/>
                            <span className="self-center">Producto</span>
                            <input className={`${classNameInput} min-h-0 `} value={detalleIncidencia.nomProductoInterno} disabled/>
                            <span className="self-center">Concepto</span>
                            <select
                                className={`${classNameSelect} w-full`}
                                disabled={true}
                                value={datosValidacion.codIncidenciaConcepto}
                            >
                                {
                                    conceptosIncidencia.length > 0 &&
                                    conceptosIncidencia.map(data => (
                                        <option
                                            key={data.codIncidenciaConcepto + '_option'}
                                            value={data.codIncidenciaConcepto}
                                        >{data.nomIncidenciaConcepto}</option>
                                    ))
                                }
                            </select>
                            <span className="self-center">Descripción</span>
                            <textarea className={`${classNameInput}`} value={detalleIncidencia.descripcionIncidencia} disabled/>
                            <span className="self-center">Imagen</span>
                            <section className={`${imagenesDetalle.length > 0 ? ' h-[130px]' : ' h-[80px] '} `}>
                                <ContenedorImagen archivo={imagenes} esBloqueo={true} envioImagen={envioImagen} showThumbs={false}/>
                            </section>
                        </section>
                    </fieldset>
                    <fieldset className="border border-zinc-600 m-2 rounded px-2">
                        <legend className="px-2">Detalle validación</legend>
                        <section className="grid grid-cols-[minmax(0,15fr)_minmax(0,35fr)_minmax(0,15fr)_minmax(0,35fr)] gap-y-1 gap-x-2 p-2">
                            <span className="self-center">Comentario</span>
                            <textarea className={`${classNameInput}`} value={datosValidacion.comentarioAtencion} disabled/>
                            <span className="self-center">Imagenes</span>
                            <section className={`${imagenesValidacion.length > 0 ? ' h-[130px]' : ' h-[80px] '} `}>
                                <ContenedorImagen archivo={imagenesExtra} esBloqueo={true} envioImagen={envioImagenExtra} showThumbs={false}/>
                            </section>
                            <span>Prioridad</span>
                            <select className={`${classNameInput} min-h-0 `} value={datosValidacion.codUrgencia} disabled>
                                {
                                    tipoUrgencia.length > 0 ? 
                                    tipoUrgencia.map(urg => (
                                        <option value={urg.codUrgencia}>{urg.nomUrgencia}</option>
                                    ))
                                    :   <option value={0}>--Sin opcion--</option>
                                }
                            </select>
                        </section>
                    </fieldset>
                    <fieldset className="border border-zinc-600 m-2 rounded px-2">
                        <legend className="px-2">Detalle solución</legend>
                        <section className="grid grid-cols-[minmax(0,15fr)_minmax(0,35fr)_minmax(0,15fr)_minmax(0,35fr)] gap-y-1 gap-x-2 p-2">
                            <span>Participantes</span>
                            {/* <ul className="list-disc ml-5">
                                {
                                    resolucion.uidSolucionConcatenado.split(',').map(uid => (
                                        <li className="">{uid}</li>
                                    ))
                                }
                            </ul> */}
                            <input className={`${classNameInput} min-h-0 `} value={resolucion.uidSolucionConcatenado} disabled/>
                            <span>Fecha atención</span>
                            <input className={`${classNameInput} min-h-0 `} value={resolucion.fechaHoraInicioAtencion} disabled/>
                            <span className="self-center">Causa</span>
                            <textarea className={`${classNameInput}`} value={resolucion.causaIncidencia} disabled/>
                            <span className="self-center">Solución</span>
                            <textarea className={`${classNameInput}`} value={resolucion.comentarioSolucion} disabled/>
                            <span>Tiempo total de atención</span>
                            <input className={`${classNameInput} min-h-0 `} value={convertirSegundosAFormatoHr(resolucion.segundosTotalAtencion)} disabled/>
                        </section>
                    </fieldset>
                </section>
            </ModalProyecto>

            <Modal
                isOpen={isOpenModalActividad}
                closeModal={closeModalActividad}
                action={()=> registrarSolucion()}
                title={`Solucionar ticket [ ${codigoIncidencia} ]`}
            >
                <section className="grid gap-y-1 w-[600px] ">
                    <span>Causa</span>
                    <textarea
                        className={`${classNameInput} h-[100px]`}
                        placeholder="Escribir la causa..."
                        value={solucion.causaIncidencia}
                        onChange={(e)=> editarValorSolucion('causaIncidencia', e.target.value)}
                    />
                    <span>Solución</span>
                    <textarea
                        className={`${classNameInput} h-[100px]`}
                        placeholder="Escribir la solución de la incidencia..."
                        value={solucion.comentarioSolucion}
                        onChange={(e)=> editarValorSolucion('comentarioSolucion', e.target.value)}
                    />
                </section>
            </Modal>
        </>
    )
}